import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { HistoryLayout } from '../../../../common/history/history-layout.component';
import { TablePagination } from '../../../../common/details-table/table-pagination.component';
import { locationSiteHistoryActions } from "../../../../../store/external/inventory/locationsite/locationsite-history.reducer";
import { Loading } from '../../../../common/loading';
import { MODAL_CUSTOM_MESSAGE } from "../../../../../constants/external-constants";

class LocationSiteHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false,
            isLoading: true,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }
    }
    componentDidMount() {
        const { getLocationSiteHistoryLogs, locationId } = this.props;

        getLocationSiteHistoryLogs(locationId)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    componentWillUnmount() {
        this.props.resetLocationSiteHistory();
    }

    getTableData(pageIndex) {
        this.props.getLocationSiteHistoryLogs(this.props.locationId, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizeLocationSiteHistoryLogs, getLocationSiteHistoryLogs, locationId } = this.props;
        resizeLocationSiteHistoryLogs(pageSize)
        this.setState({ isLoading: true });

        getLocationSiteHistoryLogs(locationId)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    locationPaginationAction = (pageIndex) => {
        const { getLocationSiteHistoryLogs, locationId } = this.props;
        getLocationSiteHistoryLogs(locationId, pageIndex);
    }

    onColumnSearch = () => {
        const { getLocationSiteHistoryLogs, locationId } = this.props;
        getLocationSiteHistoryLogs(locationId, 0);
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }
    onClickExtract = () => {
        const { locationId, extractLocationHistoryLogs } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractLocationHistoryLogs(locationId);
        }
    }


    render() {
        const { setLocationSiteColSearchStr, isReadOnly, isReadAndExtractOnly, isReadAndWrite } = this.props;
        const { Headers, Data, Pagination } = this.props.locationHistory.HistoryTable;
        return (
            <div>
                <HistoryLayout
                    displaySearchBox={this.displaySearchBox}
                    extractAction={this.onClickExtract}

                    //Access Type
                    isReadOnly={isReadOnly}
                    isReadAndExtractOnly={isReadAndExtractOnly}
                    isReadAndWrite={isReadAndWrite}
                    hideCustomColumn={true}
                >
                    <TablePagination
                        key="table-pagination-key"
                        columns={Headers}
                        pageList={Data}
                        pages={Pagination}
                        paginationAction={this.locationPaginationAction}
                        onColumnSearch={() => { this.onColumnSearch() }}
                        onColumnSearchChange={setLocationSiteColSearchStr}
                        isColSearchShow={this.state.enableSearchBox}
                        resizePage={this.resizePage}
                        totalPage={Pagination.TotalEntries}
                        isNotSortable={true}
                        isLoading={this.state.isLoading}
                    />
                </HistoryLayout>
            </div>
        );
    }
}

export default connect(
    state => {
        const { locationHistory } = state;

        return {
            locationHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, locationSiteHistoryActions),
        dispatch
    )
)(LocationSiteHistory);